import $ from 'jquery'

global.$ = $;
global.jQuery = $;
window.$ = $;

global.bootstrap = window.bootstrap = require('bootstrap')

//import * as Sentry from "@sentry/browser";
//import { BrowserTracing } from "@sentry/tracing";


require('select2');
require('/Framework/assets/js/cms-select2');
require('../../../Framework/assets/js/cms-datepicker');
//require('../../../Framework/assets/js/cms-ajax-form');
require('/Project/Framework/assets/js/cms-ajax-form.js');
require('./cms-element-duplicator');
require('../../../Framework/assets/js/cms-form-conditions')
require('../../../Modules/Captcha/assets/js/cms-captcha')
require('../../../Framework/assets/js/cms-password')
require('../../../Project/Modules/Media/assets/media');
require('../../../Project/Modules/Attributes/assets/js/applicant_address')
require('../../../Project/Modules/Attributes/assets/js/attribute_project_timeframe')
require('../../../Project/Modules/General/assets/js/wrap')
require('./disable-empty-filter-fields')
require('./accordion-init')
require('./fancybox-init')
require('./action-confirmation')
require('./popover-init')
require('./tooltip-init')
require('./form-helpers')
require('./modal-init')
require('./collection-init')
require('./carousel-init')
require('./table-orderable')
require('./modal-login')
require('./header')
require('./content')
// require('./disabilities');

require('flatpickr')
require('./components/CalendarInput');
require('./components/LanguageInput');
require('./components/OwnerInput');
require('./components/InitialInquiryInput');



window.checkRulesAgreement = function () {
    $("[name='agree_rules']").each(function () {
        this.checked = true
    })
    Fancybox.close();
}
